/* eslint no-unneeded-ternary: 0 */

import { PaymentTypesRepository, TransactionsRepository } from 'common/repositories/index';
import { ExpiredLicensesProcessor } from 'common/repositoryProcessors/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Cookie from 'common/services/util/-RFC.Cookie';
import Recaptcha from 'services/recaptcha';

(() => {

    /**
     * Controller for the device details page
     */

    angular.module('controllers')
        .controller(
            'MyAccount',
            ($scope, $state) => {

                $scope.state = $state;

                $scope.paymentTypes = PaymentTypesRepository.getAll();
                /**
             * Returnes true if the user is loggedin with facebook or google
             */
                $scope.isSocialAccount = () => {

                // facebook, google, or password
                    const userLoginType = Cookie.get(CWCONFIG.cookie.loginType);

                    return !userLoginType || userLoginType === 'password' ? false : true;

                };

                $scope.loginAccountType = Cookie.get(CWCONFIG.cookie.loginType);

                $scope.onTabClick = (tabName) => {

                    Mixpanel.send(`ConnectWeb ${tabName} Tab Click`);

                };

                $scope.transactions = TransactionsRepository.getAll()
                    .filter((transaction) => {

                        if (transaction.attributes.price) {

                            const formatPrice = transaction.attributes.price.replace(',', '');

                            return Number(formatPrice) > 0;

                        }

                        return false;

                    });

                $scope.Recaptcha = Recaptcha;
                $scope.setCaptchaResponse = (response) => {

                    $scope.Recaptcha.setCaptchaResponse(response);
                    $scope.$broadcast('captcha available');

                };

                // Check if agent id (aid) exists and has a numeric value on session storage
                if (sessionStorage.getItem('aid') && !Number.isNaN(parseInt(sessionStorage.getItem('aid'), 0))) {

                    // Show the otc tab for support agents only
                    $scope.showOTCTab = true;

                }

                $scope.expiredLicenses = ExpiredLicensesProcessor.getAll();

            },
        );

})();



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/my-account/my-account.js